import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Button } from './ui/Button';
export function OfferSection() {
  return <SectionWrapper id="oferta" className="pb-32" data-id="element-80">
      <div className="bg-card rounded-sm shadow-warm-lg border border-subtle p-8 md:p-12 text-center max-w-2xl mx-auto relative overflow-hidden" data-id="element-81">
        {/* Subtle decorative top border */}
        <div className="absolute top-0 left-0 w-full h-1 bg-amber opacity-80" data-id="element-82"></div>

        <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-6" data-id="element-83">
          Recupera la paz en tu hogar hoy mismo.
        </h2>

        <p className="text-lg text-secondary font-body mb-8 leading-relaxed" data-id="element-84">
          No esperes a que el silencio se vuelva un muro imposible de derribar.
          Mañana puede ser el día en que por fin vuelvan a conectar.
        </p>

        <div className="py-8 border-y border-subtle mb-8" data-id="element-85">
          <p className="text-primary font-medium mb-2" data-id="element-86">
            Obtén el Sistema Completo "Ya No me Habla" por solo
          </p>
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-87">
            <span className="text-2xl text-secondary font-heading line-through opacity-60" data-id="element-88">
              $19 USD
            </span>
            <span className="inline-block bg-amber text-white text-sm font-bold px-3 py-1 rounded-sm" data-id="element-89">
              -66% OFF
            </span>
          </div>
          <div className="text-5xl font-heading font-bold text-primary" data-id="element-90">
            $6.39{' '}
            <span className="text-2xl text-secondary font-normal" data-id="element-91">USD</span>
          </div>
        </div>

        <a href="https://pay.hotmart.com/U105004551B" target="_blank" rel="noopener noreferrer" data-id="element-92">
          <Button fullWidth className="mb-4" data-id="element-93">
            QUIERO RECUPERAR LA COMUNICACIÓN CON MI HIJO
          </Button>
        </a>

        <p className="text-sm text-secondary/80 font-body flex items-center justify-center gap-2" data-id="element-94">
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-95">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-96" />
          </svg>
          Pago seguro. Acceso inmediato en PDF.
        </p>

        <div className="mt-10" data-id="element-97">
          <img src="https://cdn.magicpatterns.com/uploads/bWVGTh4mgijtFf6yM62WRk/Mockup_El_Codigo_del_Silencio_2.png" alt="Familia reunida en el sofá reconectando después de leer Ya No me Habla" className="w-full max-w-md mx-auto rounded-sm" data-id="element-98" />
        </div>
      </div>
    </SectionWrapper>;
}